import Vue from "vue";
import VueRouter from "vue-router";
import Meta from "vue-meta";

import NotFound from "../views/NotFound.vue";
import Home from "../views/Home.vue";
import HomeCompany from "../views/HomeCompany.vue";
import Info from "../views/Info.vue";
import Companies from "../views/Companies.vue";
import Company from "../views/Company.vue";
import Requests from "../views/Requests.vue";
import RequestForm from "../views/RequestForm.vue";
import Request from "../views/Request.vue";
import IframeContent from "../views/IframeContent.vue";

import CompaniesFacets from "../views/Companies-facet.vue";

//logga-in
import Login from "../views/Login.vue";
import ForgottenPassword from "../views/ForgottenPassword.vue";

//MyPages
import MyPages from "../views/MyPages.vue";
import MyPagesRequests from "../views/my-pages-sublayouts/MyPagesRequests.vue";
import MyPagesProfile from "../views/my-pages-sublayouts/MyPagesProfile.vue";
import MyPagesSearchProfile from "../views/my-pages-sublayouts/MyPagesSearchProfile.vue";
import MyPagesAccount from "../views/my-pages-sublayouts/MyPagesAccount.vue";

Vue.use(VueRouter);
Vue.use(Meta, {
    keyName: "metaData",
    attribute: "data-brabyggare-meta",
    ssrAttribute: "data-brabyggare-meta-server-rendered",
    tagIDKeyName: "vmid"
});

export default () => {
    return new VueRouter({
        mode: "history",
        base: __dirname,
        scrollBehavior: function(to, from, savedPosition) {
            // scroll to anchor
            if (
                savedPosition ||
                (to.name === "HantverkareFilter" &&
                    (to.name === from.name || from.name === "Sök hantverkare"))
            ) {
                return savedPosition;
            } else {
                if (to.hash) {
                    return { selector: to.hash };
                } else {
                    return { x: 0, y: 0 };
                }
            }
        },
        routes: [
            {
                name: "Hem",
                path: "/",
                component: Home
            },
            {
                name: "Hem (Hantverkare)",
                path: "/for-hantverkare/",
                component: HomeCompany
            },
            {
                name: "Förfrågan",
                path: "/requestpuff/",
                component: IframeContent
            },
            {
                name: "Info",
                path: "/info/:slug",
                component: Info
            },
            {
                name: "Hantverkare",
                path: "/hantverkare/:identifier",
                component: Company
            },
            {
                name: "Sök hantverkare",
                path: "/sok-hantverkare/",
                component: CompaniesFacets
                //component: Companies,
            },
            {
                name: "HantverkareFilter",
                path: "/sok-hantverkare/filter/:region/:category?/",
                component: CompaniesFacets,
                pathToRegexpOptions: { strict: true }
            },
            {
                name: "Hantverkare profil",
                path: "/sok-hantverkare/:slug",
                redirect: to => {
                    return `/hantverkare/${to.params.slug}`;
                }
            },
            {
                name: "Sök förfrågan",
                path: "/sok-forfragan/",
                component: Requests
            },
            {
                name: "Förfrågan",
                path: "/forfragan/:id",
                component: Request
            },
            {
                name: "Skapa förfrågan",
                path: "/skapa-forfragan/:id?",
                component: RequestForm
            },
            {
                name: "Logga in",
                path: "/logga-in/",
                component: Login,
                meta: {
                    redirect: "/mina-sidor/",
                    requiresAuth: true,
                    role: ["Guest"]
                }
            },
            {
                name: "Glömt lösenordet?",
                path: "/logga-in/glomt-losenordet/",
                component: ForgottenPassword
            },
            {
                path: "/inloggning/",
                redirect: "/logga-in/"
            },
            {
                path: "/glomt-losenord/",
                redirect: "/glomt-losenordet/"
            },
            {
                path: "/mina-sidor",
                name: "Mina sidor",
                component: MyPages,
                redirect: { name: "Förfrågningar" },
                children: [
                    {
                        name: "Förfrågningar",
                        path: "forfragningar",
                        component: MyPagesRequests,
                        meta: {
                            redirect: "/logga-in/",
                            requiresAuth: true,
                            role: ["Customer", "Company"]
                        }
                    },
                    {
                        name: "Profil",
                        path: "profil",
                        component: MyPagesProfile,
                        meta: {
                            redirect: "/logga-in/",
                            requiresAuth: true,
                            role: ["Company"]
                        }
                    },
                    {
                        name: "Mitt konto",
                        path: "konto",
                        component: MyPagesAccount,
                        meta: {
                            redirect: "/logga-in/",
                            requiresAuth: true,
                            role: ["Customer", "Company"]
                        }
                    },
                    {
                        name: "Sökprofil",
                        path: "sokprofil",
                        component: MyPagesSearchProfile,
                        meta: {
                            redirect: "/logga-in/",
                            requiresAuth: true,
                            role: ["Company"]
                        }
                    }
                ]
            },
            {
                name: "Förfrågan (Mina sidor)",
                path: "/mina-sidor/forfragningar/:id/:openModal?",
                component: Request,
                props: true,
                meta: {
                    redirect: "/logga-in/",
                    requiresAuth: true,
                    role: ["Customer", "Company"]
                }
            },
            {
                name: "Sidan finns inte",
                path: "*",
                component: NotFound
            }
        ]
    });
};



// WEBPACK FOOTER //
// ./src/router/index.js